import request from '@/utils/request'

// single history列表
export const getTableList = params =>
  request.post('/workflow-api/credit-apply/approve/page', params)

// batch history table list
export const getBatchTable = params =>
  request.post('/workflow-api/credit-batch/approve/page', params)

// 获取css详情
export const getCssDetail = params =>
  request.get(`/workflow-api/credit-css/approve/detail/${params.bpmId}`)
